// Import the RTK Query methods from the React-specific entry point
import { Paths } from './paths/paths';
import { apiSlice } from './apiSlice';
import {
  CompletedQuestionnaire,
  QuestionnaireTemplate,
} from './response/questionnaire';

export const questionnaireSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuestionnaireTemplate: builder.query<QuestionnaireTemplate, void>({
      query: () => Paths.Questionnaire,
    }),
    getCompletedQuestionnaire: builder.query<CompletedQuestionnaire, void>({
      query: () => Paths.CompletedQuestionnaire,
      providesTags: ['completed_questionnaire'],
    }),
    updateUserQuestionnaire: builder.mutation<void, CompletedQuestionnaire>({
      query: (data) => ({
        url: Paths.CompletedQuestionnaire,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['completed_questionnaire', 'User'],
    }),
  }),
});

export const {
  useGetQuestionnaireTemplateQuery,
  useGetCompletedQuestionnaireQuery,
  useUpdateUserQuestionnaireMutation,
} = questionnaireSlice;
